import React, { useState } from 'react'
import { Form, Formik } from 'formik'
import Button from '../common/Button'
import { required } from '../../utils/validators'
import Input from '../common/Input'
import Select from '../common/Select'

export default function AnimalForm({ onSubmit, initialValues, animalTypes, onCancel }) {
    const [imagePreview, setImagePreview] = useState(initialValues?.imageUrl || null)
    const [ageCategory, setAgeCategory] = useState(initialValues?.ageCategory || 'adult')

    const genderOptions = [
        { value: 'male', label: 'Erkak' },
        { value: 'female', label: 'Ургочи' },
    ]

    const ageCategoryOptions = [
        { value: 'baby', label: 'Бола' },
        { value: 'adult', label: 'Катта' },
    ]

    const acquisitionTypeOptions = [
        { value: 'from_farm', label: 'Молхонада' },
        { value: 'born_here', label: 'Молхонада туғилди' },
        { value: 'purchased', label: 'Сотиб олинди' },
    ]

    const statusOptions = [
        { value: 'active', label: 'Фаол' },
        { value: 'sold', label: 'Сотилди' },
        { value: 'died', label: 'Ўлди' },
        { value: 'lost', label: 'Йўқолди' },
    ]

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                identificationNumber: '',
                gender: '',
                ageCategory: 'adult',
                acquisitionType: 'purchased',
                birthDate: '',
                animalType: '',
                notes: '',
                image: null,
                status: 'active',
                disposalDate: '',
                disposalReason: '',
                soldPrice: '',
                weight: '',
                ...initialValues
            }}
        >
            {({ setFieldValue, values }) => (
                <Form>
                    <Input
                        name="identificationNumber"
                        label="Идентификация рақами"
                        validate={required}
                        placeholder="Масалан: A001"
                    />

                    <Select
                        name="gender"
                        label="Жинси"
                        validate={required}
                        options={genderOptions}
                        optionValue="value"
                        optionLabel="label"
                    />

                    <Select
                        name="ageCategory"
                        label="Ёш тоифаси"
                        validate={required}
                        options={ageCategoryOptions}
                        optionValue="value"
                        optionLabel="label"
                        onChange={(e) => {
                            setAgeCategory(e.target.value)
                            setFieldValue('ageCategory', e.target.value)
                        }}
                    />

                    <Select
                        name="acquisitionType"
                        label="Келиб чиқиши"
                        validate={required}
                        options={acquisitionTypeOptions}
                        optionValue="value"
                        optionLabel="label"
                    />

                    <Select
                        name="animalType"
                        label="Ҳайвон тури"
                        validate={required}
                        options={(animalTypes || []).map((type) => ({
                            value: type.id,
                            label: type.name
                        }))}
                        optionValue="value"
                        optionLabel="label"
                    />

                    {(values.ageCategory === 'baby' || ageCategory === 'baby') && (
                        <>
                            <Input
                                name="birthDate"
                                type="date"
                                label="Туғилган сана"
                                validate={required}
                            />
                            <p className="help is-info">
                                <ion-icon name="information-circle-outline" style={{ verticalAlign: 'middle' }} />
                                {' '}Бола ҳайвонлар учун туғилган сана мажбурий
                            </p>
                        </>
                    )}

                    <div className="field">
                        <label className="label">Расм</label>
                        <div className="control">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    const file = e.target.files[0]
                                    if (file) {
                                        setFieldValue('image', file)
                                        const reader = new FileReader()
                                        reader.onloadend = () => {
                                            setImagePreview(reader.result)
                                        }
                                        reader.readAsDataURL(file)
                                    }
                                }}
                                className="input"
                            />
                        </div>
                        {imagePreview && (
                            <div className="mt-3">
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }}
                                />
                            </div>
                        )}
                    </div>

                    <Input
                        name="weight"
                        label="Вазн (кг)"
                        type="number"
                        placeholder="Масалан: 45.5"
                    />

                    <Input
                        name="notes"
                        label="Изоҳ"
                        placeholder="Қўшимча маълумот"
                    />

                    <Select
                        name="status"
                        label="Ҳолати"
                        validate={required}
                        options={statusOptions}
                        optionValue="value"
                        optionLabel="label"
                    />

                    {values.status === 'sold' && (
                        <Input
                            name="soldPrice"
                            type="number"
                            label="Сотилган нарх (сўм)"
                            placeholder="Масалан: 5000000"
                            validate={required}
                        />
                    )}

                    {values.status !== 'active' && (
                        <>
                            <Input
                                name="disposalDate"
                                type="date"
                                label="Айириш санаси"
                                validate={required}
                            />

                            <div className="field">
                                <label className="label">Айириш сабаби</label>
                                <div className="control">
                                    <textarea
                                        name="disposalReason"
                                        className="textarea"
                                        placeholder="Ҳайвонни айириш сабабини ёзинг..."
                                        value={values.disposalReason || ''}
                                        onChange={(e) => setFieldValue('disposalReason', e.target.value)}
                                        rows="3"
                                    />
                                </div>
                                <p className="help is-warning">
                                    <ion-icon name="alert-circle-outline" style={{ verticalAlign: 'middle' }} />
                                    {' '}Ҳайвон айирилган сабабни батафсил ёзинг
                                </p>
                            </div>
                        </>
                    )}

                    <div className="is-pulled-right mt-4">
                        {onCancel && (
                            <>
                                <Button onClick={onCancel} icon="close-outline" text="Ёпиш" className="is-danger" />
                                &nbsp;&nbsp;
                            </>
                        )}
                        <Button text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                    </div>
                </Form>
            )}
        </Formik>
    )
}
